import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { SelectModule } from 'primeng/select';
import { DragDropService } from '../../../services/builder/drag-drop.service';
import { WidgetService } from '../../../services/builder/widget.service';
import { ComboBoxCPanelComponent } from './customizationPanel';

export interface ComboBoxCustomization {
  defaultValue: string | number;
  options: Array<{
    label: string;
    value: string | number;
    valueEqualsDescription: boolean;
    weight: number;
  }>;
  autocompleteRule: boolean;
  required: boolean;
}

@Component({
  selector: 'lib-combobox-edit',
  imports: [SelectModule, ComboBoxCPanelComponent, FormsModule],
  template: `
    <!-- CONFIGURATION PANEL -->
    @if (widgetService.settingVisibility()) {
      <lib-combobox-custom-panel />
    }

    <!-- OBJECT RAPRESENTATION -->
    @let widget = widgetService.widget();
    @if (widget) {
      <div class="relative flex h-full w-full flex-col gap-2">
        @if (!widgetService.baseElementShowDescription()) {
          <div class="flex flex-row items-center">
            {{ widgetService.computedDescription() }}
          </div>
        }
        <div class="p-fluid flex flex-row">
          <p-select
            [autofocus]="false"
            id="data"
            [ngModel]="this.widgetService.widget()?.customization.defaultValue"
            [options]="widget.customization.options"
            optionValue="value"
            optionLabel="label"
            class="w-full"
            [disabled]="true"
          />
        </div>
      </div>
    }
  `,
  styleUrls: ['../style.css'],
})
export class ComboBoxComponent {
  protected dragDropService = inject(DragDropService);
  protected widgetService = inject(WidgetService<ComboBoxCustomization>);
}
